<template>
    <div id="main" class="is-flex">
        <div class="page">
            <div class="vertical-flow">
                <!-- TÍTULO -->
                <h1 class="title">
                    {{ $t('config-smtp') }}
                    <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                        <b-icon v-if="!hide.infoIsHidden" icon="eye-off-outline" type="is-danger" />
                        <b-icon v-if="hide.infoIsHidden" icon="eye-outline" type="is-success" />
                    </a>
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t('settings') }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{ $t('config-smtp') }}</a>
                        </li>
                    </ul>
                </nav>

                <!-- BOTÕES PARTE SUPERIOR -->
                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        :disabled="isTesting || isSaving || !config.active || !changedPassword"
                        @click="testConnection"
                    >
                        {{ $t('testar-config') }}
                    </button>

                    <button
                        v-if="
                            (!isUpdate && permissao.create && config.active) ||
                            (isUpdate && permissao.update)
                        "
                        class="save-btn"
                        type="button"
                        :disabled="isTesting"
                        @click="save"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>

                <!-- FORMULÁRIO -->
                <div class="columns mt-0">
                    <div class="column is-narrow">
                        <b-checkbox
                            class="active-checkbox"
                            type="is-primary"
                            v-model="config.active"
                        >
                            {{ $t('ativa-config') }}
                        </b-checkbox>
                    </div>
                    <div class="column is-half-tablet is-one-third-widescreen">
                        <div class="columns is-multiline">
                            <div class="column is-full">
                                <v-input
                                    ref="endInput"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    class="lower"
                                    title="servidor"
                                    v-model.trim="config.serverAddr"
                                    :maxlength="100"
                                    :disabled="!config.active"
                                    :invalid="!config.serverAddr"
                                    no-clearfix
                                    :uppercase="false"
                                />
                            </div>
                            <div class="column is-full">
                                <v-input
                                    ref="portInput"
                                    class="lower"
                                    title="porta"
                                    v-model.trim="config.serverPort"
                                    type="number"
                                    min="1"
                                    max="65535"
                                    :disabled="!config.active"
                                    :invalid="
                                        !config.serverPort ||
                                        isNaN(parseInt(config.serverPort)) ||
                                        parseInt(config.serverPort) < 1 ||
                                        parseInt(config.serverPort) > 65535
                                    "
                                    :msg="
                                        parseInt(config.serverPort) < 1 ||
                                        parseInt(config.serverPort) > 65535
                                            ? 'msg-server-port-range'
                                            : 'msg-campo-obrigatorio'
                                    "
                                    no-clearfix
                                />
                            </div>
                            <div class="column is-full">
                                <v-input
                                    ref="userInput"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    class="lower"
                                    title="usuario"
                                    v-model.trim="config.username"
                                    :maxlength="50"
                                    :invalid="!config.username"
                                    :disabled="!config.active"
                                    no-clearfix
                                    :uppercase="false"
                                />
                            </div>
                            <div class="column is-full">
                                <label v-text="$t('conf-smtp-senha')" />
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="$t('msg-smtp-senha')"
                                />
                                <v-input
                                    ref="passwordInput"
                                    :hideInfo="hide.hideInfo"
                                    :infoIsHidden="hide.infoIsHidden"
                                    class="lower"
                                    v-model.trim="config.password"
                                    :placeholder="changedPassword ? '' : 'senha-criptografada'"
                                    :maxlength="50"
                                    :disabled="!config.active || !config.alterPassword"
                                    :invalid="
                                        (!config.password && !isUpdate) ||
                                        (!config.password && config.alterPassword && isUpdate)
                                    "
                                    @input="updateChangedPassword"
                                    no-clearfix
                                    :uppercase="false"
                                />
                            </div>
                            <div class="column is-full" v-show="isUpdate">
                                <b-checkbox
                                    type="is-primary"
                                    v-model="config.alterPassword"
                                    :disabled="!config.active"
                                >
                                    Alterar senha?
                                </b-checkbox>
                            </div>
                            <div class="column is-full">
                                <b-checkbox
                                    type="is-primary"
                                    v-model="config.useTLS"
                                    :disabled="!config.active"
                                >
                                    {{ $t('utiliza-tls') }}
                                </b-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConfigSmtpService from '@/services/ConfigSmtpService';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        HideInfo,
    },
    data() {
        return {
            service: new ConfigSmtpService(this.$http, this.$router),
            isSaving: false,
            cleanHide: true,
            isTesting: false,
            config: {
                serverAddr: '',
                serverPort: '',
                username: '',
                password: '',
                useTLS: false,
                active: false,
                /*
                 * @70193 - Variável que controla se o usuário quer alterar a senha
                 * ou não.
                 */
                alterPassword: false,
            },
            /*  Flag que diz se o conteúdo do campo senha foi modificado.
                    Utilizado para mostrar o placeholder "Senha Criptografada",
                    visto que a senha não vem junto na requisição.*/
            changedPassword: false,
            /* chave utilizada para criptografar a chave da api, em b64 */
            hk: 'UzBWMVMyMDA3UzBWMVMyMDE5UzBWMVMuIUAj',
            isUpdate: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('admin', 'config-smtp', 'configuracao-smtp');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'config-smtp' },
            });
        } else {
            this.load();
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        load() {
            this.$store.commit('addLoader');

            this.service
                .find()
                .then((r) => {
                    /* r.content vem null se não existe a config no banco */
                    if (r.content) {
                        this.config = r.content;
                        this.isUpdate = true;
                    } else {
                        /*  Se vem null não faz sentido mostrar a flag que ativa
                                o placeholder "Senha Criptografada", então ela é modificada aqui. */
                        this.changedPassword = true;
                        this.config.alterPassword = true;
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar a configuração.', e);
                    this.$root.showMessage('error', 'msg-error-loading-smtp-config');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        testConnection() {
            if (this.validate()) {
                this.isTesting = true;

                /*  Como não vai salvar as informações para testar a conexão,
                        então não é necessário criptografar a senha antes de mandar. */
                this.service
                    .test(this.config)
                    .then((r) => {
                        /*  r.content contém uma flag dizendo se o teste foi bem sucedido
                                ou não. A mensagem de erro vem junto em r.message, mas durante
                                os testes, a mensagem de erro foi genérica independente do motivo 
                                do erro. Então ela não é usada aqui. */
                        if (r.content === true) {
                            this.$root.alert({
                                message: this.$t('msg-test-conn-success'),
                            });
                        } else {
                            this.$root.alert({
                                message: this.$t('msg-test-conn-failure'),
                            });
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao realizar teste.', e);
                        this.$root.alert({
                            message: this.$t('msg-test-failure'),
                        });
                    })
                    .finally((_) => {
                        this.isTesting = false;
                    });
            }
        },
        save() {
            if (this.validate()) {
                this.isSaving = true;

                /* Cria uma cópia do objeto, pra não alterar a senha que está no formulário */
                let cfg = { ...this.config };

                /* E então a senha é criptografada antes do envio. */
                if (cfg.password && cfg.password.length > 0) {
                    cfg.password = this.$CryptoJS.AES.encrypt(
                        cfg.password,
                        atob(this.hk)
                    ).toString();
                } else {
                    cfg.password = null;
                }

                this.service
                    .save(cfg)
                    .then((r) => {
                        this.$root.showMessage('success', 'msg-server-config-save-success');
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar configuração SMTP.', e);
                        this.$root.showMessage('error', 'msg-server-config-save-failure');
                    })
                    .finally((_) => {
                        this.load();
                        this.isSaving = false;
                    });
            }
        },
        validate() {
            let valid = true;

            /*  Como os campos são desabilitados com a configuração inativa
                    não faz sentido validar eles com isso. */
            if (this.config.active) {
                if (!this.config.serverAddr) {
                    this.$root.showMessage('error', 'msg-server-addr-obrigatorio');
                    this.$refs.endInput.focusedOut = true;
                    valid = false;
                }

                let port = parseInt(this.config.serverPort);

                if (!this.config.serverPort || isNaN(port)) {
                    this.$root.showMessage('error', 'msg-server-port-obrigatorio');
                    this.$refs.portInput.focusedOut = true;
                    valid = false;
                }

                if (valid && (port < 1 || port > 65535)) {
                    this.$root.showMessage('error', 'msg-server-port-range');
                    this.$refs.portInput.focusedOut = true;
                    valid = false;
                }

                if (!this.config.username) {
                    this.$root.showMessage('error', 'msg-username-obrigatorio');
                    this.$refs.userInput.focusedOut = true;
                    valid = false;
                }

                /*
                 * @70193 - Verificando caso o usuário deseje alterar a senha
                 * se o campo de senha não está vazio.
                 */
                if (
                    (this.config.alterPassword && !this.config.password) ||
                    (!this.isUpdate && !this.config.password)
                ) {
                    this.$root.showMessage('error', 'msg-password-obrigatorio');
                    this.$refs.passwordInput.focusedOut = true;
                    valid = false;
                } else {
                    this.$refs.passwordInput.focusedOut = false;
                }
            }

            return valid;
        },
        updateChangedPassword() {
            if (!this.changedPassword) {
                this.changedPassword = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px 20px 20px;
    min-height: 100%;

    .page {
        h1 {
            margin-bottom: 40px;

            &.title {
                margin-right: 550px;
            }
        }

        .active-checkbox {
            padding-top: 5px;
        }
    }
}
</style>
